import { requestJson } from "./apiClient";

export function dataSourceDeletionRequest(source, domain) {
  return {
    domain,
    sourceKey: source?.sourceKey || source?.sourceCode,
    sourceName: source?.displayName || source?.sourceName,
    automotiveSourceKey: source?.automotiveSourceKey || undefined,
    vehicleSourceKey: source?.vehicleSourceKey || undefined,
  };
}

export function previewDataSourceDeletion(source, domain) {
  return requestJson("/api/admin/data-sources/deletion-preview", {
    method: "POST",
    body: JSON.stringify(dataSourceDeletionRequest(source, domain)),
  });
}

export function deleteDataSource(source, domain) {
  return requestJson("/api/admin/data-sources", {
    method: "DELETE",
    body: JSON.stringify(dataSourceDeletionRequest(source, domain)),
  });
}
